<div class="inner-page-banner" style="margin-bottom: var(--mb-60)">
  <picture>
    <source srcset="https://media.umangapp.in/cdn/landing/theme/aboutus.webp" />
    <img
      src="https://media.umangapp.in/cdn/landing/theme/aboutus.jpg"
      alt="about umang"
      width="1306"
      height="376"
      class="resp-image w-100"
      loading="lazy"
      fetchpriority="high"
      
    />
  </picture>
</div>

<!-- About-us heading section -->
<section class="about-us" style="margin-bottom: var(--mb-common)">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="about-video">
          <iframe
            src="https://www.youtube.com/embed/k79qOiZ42C4"
            frameborder="0"
          ></iframe>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="about-content text-start d-flex align-items-start flex-column justify-content-center h-100"
        >
          <h1>{{ "about-us.head" | translate }}</h1>
          <p>
            {{ "about-us.desc" | translate }}
          </p>
          <p>
            {{ "about-us.sub-desc" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Testimonials section -->
<section class="testimonials" style="margin-bottom: var(--mb-common)">
  <div class="container">
    <div class="multi-item-carousel-wrapper-testimonial">
      <div class="carousel-heading">
        <h2 class="main-heading mb-0 text-white">
          {{ "about-us.testimonials" | translate }}
        </h2>
      </div>
      <swiper
        [config]="testimonialSliderConfig"
        class="multi-slides multi-slides--testimonial"
      >
        <ng-template
          swiperSlide
          class="slide"
          *ngFor="let testimonial of testimonials"
        >
          <div class="card card--testimonial">
            <div class="testimonial-header d-flex align-items-center">
              <span [innerHTML]="userSVG | safeHTML"></span>
              <div class="user-info">
                <h3 class="user-name">{{ testimonial.name }}</h3>
                <p class="date">{{ testimonial.date }}</p>
              </div>
            </div>
            <div class="testimonial-body">
              <div class="user-content">
                <p class="mb-0">{{ testimonial.content }}</p>
              </div>
            </div>
          </div>
        </ng-template>
      </swiper>
    </div>
  </div>
</section>

<!-- Gallery section -->
<section class="gallery">
  <div class="container">
    <div class="carousel-heading">
      <h2 class="main-heading mb-1">{{ "gallery.head" | translate }}</h2>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div
          class="gallery-buttons d-flex align-items-center justify-content-center"
        >
          <ul>
            <li
              *ngFor="let config of galleryConfig; let i = index"
              [ngClass]="{ active: selectedIndex == i }"
              (click)="selectedIndex = i"
            >
              {{ config.label | translate }}
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-9 gallery-carousel">
        <swiper [config]="gallerySliderConfig" class="gallery-slider">
          <ng-template
            swiperSlide
            *ngFor="
              let gallery of galleryConfig[selectedIndex].content;
              let i = index
            "
          >
            <iframe
              *ngIf="gallery.video; else galleryImg"
              class="gallery-video"
              allowfullscreen
              width="100%"
              height="244"
              [src]="gallery.video | safeUrl"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>

            <ng-template #galleryImg>
              <picture *ngIf="gallery.image">
                <source [srcset]="gallery.imageWebp | safeUrl" />
                <img
                  class="w-100 gallery-image"
                  imgFallback
                  loading="lazy"
                  fetchpriority="high"
                  
                  [src]="gallery.image | safeUrl"
                  alt="gallery"
                />
              </picture>
            </ng-template>
          </ng-template>
        </swiper>
      </div>
    </div>
  </div>
</section>

<!-- Contact-us section -->
<div
  #contactUs
  class="container"
  style="margin-bottom: var(--mb-common)"
>
  <app-contact-info></app-contact-info>
</div>
